import React, { useState, useEffect } from "react";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Divider from "@mui/material/Divider";

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

export default function RTBillsTab(props) {
  const classes = useStyles();
  const [value, setValue] = useState(props.selectedTab);
  const currentusertype = localStorage.getItem('userType');
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const options = JSON.parse(localStorage.getItem('memoptions')) || [];

  const handleChange = (event, newValue) => {
    if (newValue === '0') {
      let stateObj = { id: "100" };
      window.history.pushState(stateObj, "Bills", '/admin/bills?tab=bill');
    }
    else if (newValue === '1') {
      let stateObj = { id: "101" };
      window.history.pushState(stateObj, "Dashboard", '/admin/bills?tab=dashboard');
    }
    else if (newValue === '2') {
      let stateObj = { id: "102" };
      window.history.pushState(stateObj, "Budgets", '/admin/bills?tab=budget');
    }
    setValue(newValue);
  };
  useEffect(() => {
    if (props.selectedTab === '0') {
      let stateObj = { id: "100" };
      window.history.pushState(stateObj, "Bills", '/admin/bills?tab=bill');
    }
    else if (props.selectedTab === '1') {
      let stateObj = { id: "101" };
      window.history.pushState(stateObj, "Dashboard", '/admin/bills?tab=dashboard');
    }
    else if (props.selectedTab === '2') {
      let stateObj = { id: "102" };
      window.history.pushState(stateObj, "Budgets", '/admin/bills?tab=budget');
    }
    setValue(props.selectedTab);
  }, [props.selectedTab]);

  return (
    <TabContext value={value} className={classes.root}>
      <div className={classes.demo2}>
        <AppBar
          position="static"
          className={classes.demo3}
          style={{ boxShadow: "none", shadowColor: "red" }}
        >
          <StyledTabs
            value={value}
            onChange={handleChange}
            aria-label="styled tabs example"
            scrollButtons="auto"
          >
            {currentusertype == 1 || (options && options.find((x) => x.id === 'bills') && permis && permis.includes('bills_access')) ?
              <StyledTab label="Factures" value="0" /> : <></>}
            {currentusertype == 1 || (options && options.find((x) => x.id === 'bills') && permis && permis.includes('bills_access')) ?
              <StyledTab label="Tableau de bord" value="1" /> : <></>}
            {currentusertype == 1 || (options && options.find((x) => x.id === 'budget') && permis && permis.includes('budget_access')) ?
              <StyledTab label="Budgets" value="2" /> : <></>}
          </StyledTabs>
          <Typography className={classes.padding} />
        </AppBar>
        <Divider variant="fullWidth" />
        {currentusertype == 1 || (options && options.find((x) => x.id === 'bills') && permis && permis.includes('bills_access')) ?
          <TabPanel value="0">{props.bills}</TabPanel> : <></>}
        {currentusertype == 1 || (options && options.find((x) => x.id === 'bills') && permis && permis.includes('bills_access')) ?
          <TabPanel value="1">{props.dashboard}</TabPanel> : <></>}
        {currentusertype == 1 || (options && options.find((x) => x.id === 'budget') && permis && permis.includes('budget_access')) ?
          <TabPanel value="2">{props.budget}</TabPanel> : <></>}
      </div>
    </TabContext>
  );
}
